/**
 * AskAiOffcanvas.js — opens/closes the "Ask about this episode" chat panel
 */
export default class AskAiOffcanvas {
  constructor() {
    this.trigger   = document.getElementById('ask-ai-trigger');
    this.panel     = document.getElementById('ask-ai-offcanvas');
    this.backdrop  = document.getElementById('ask-ai-backdrop');
    this.closeBtn  = document.getElementById('ask-ai-close');
    this.form      = document.getElementById('ask-ai-form');
    this.input     = document.getElementById('ask-ai-input');
    this.messages  = document.getElementById('ask-ai-messages');

    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.open();
    });

    this.backdrop?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());

    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.sendMessage();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.panel.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open() {
    this.panel.classList.add('is-open');
    this.panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.input?.focus(), 300);
  }

  close() {
    this.panel.classList.remove('is-open');
    this.panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  sendMessage() {
    const text = this.input.value.trim();
    if (!text) return;

    this.appendMessage(text, 'user');
    this.input.value = '';
  }

  appendMessage(text, role) {
    const row = document.createElement('div');
    row.className = `ask-ai-msg-row ask-ai-msg-row-${role}`;

    const avatar = document.createElement('span');
    avatar.className = `ask-ai-avatar ask-ai-avatar-${role}`;
    avatar.innerHTML = role === 'bot'
      ? '<img src="assets/images/star.svg" class="h-[20px]" alt="">'
      : '<i class="fa-solid fa-user"></i>';

    const bubble = document.createElement('div');
    bubble.className = `ask-ai-msg ask-ai-msg-${role}`;
    bubble.textContent = text;

    if (role === 'user') {
      row.append(bubble, avatar);
    } else {
      row.append(avatar, bubble);
    }

    this.messages.appendChild(row);
    this.messages.scrollTop = this.messages.scrollHeight;
  }
}
